import SmoothScrollIntoView from '../__frontend/smoothScrollIntoView';
import setHeaderHeight from '../__frontend/setHeaderHeight';
import Forms from '../__frontend/forms';
import viewportUnits from '../__frontend/viewportUnits';
import delayedScripts from '../__frontend/delayedScripts';

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		document.querySelector('html').classList.remove('no-js');
		SmoothScrollIntoView();
		setHeaderHeight();
		viewportUnits();
		delayedScripts();
	},
	loaded() {
		// Only add functions here that are okay to run after the entire page has loaded (include media/images).
		Forms();
		viewportUnits();
	},
	resized() {
		viewportUnits();
		setHeaderHeight();
	},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
